import Select from "react-select";
import Form from "react-bootstrap/Form";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import Account_Created_Modal from "../account-created-modal/Account_Created_Modal";
import Common_Login_Button from "../../../common_components/common-login-button/Common_Login_Button";
import "react-phone-input-2/lib/style.css";
import "./Expert_Login.css";
import { useState } from "react";

const Expert_Login = ({ activeTab }) => {
  const [mobile, setMobile] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [fullName, setFullName] = useState("");
  const [adhar, setAdhar] = useState("");
  const [loginOtp, setLoginOtp] = useState("");
  const [profession, setProfession] = useState("");
  const [experience, setExperience] = useState("");
  const [dob, setDob] = useState("");
  const [modalText, setModalText] = useState("");

  const navigate = useNavigate();

  const selectStyles = {
    control: (base) => ({
      ...base,
      height: "45px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      boxShadow: "none",
      "&:hover": { border: "1px solid #aaa" },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  const cityOptions = [
    { value: "mumbai", label: "Mumbai" },
    { value: "pune", label: "Pune" },
  ];
  const stateOptions = [{ value: "maharashtra", label: "Maharashtra" }];

  const handleChange = (value, index) => {
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);
    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (isRegistering) {
      setModalText("Account Created Successfully!");
      setShowAccountModal(true);
      setTimeout(() => {
        setShowAccountModal(false);
        setIsRegistering(false);
        setFullName("");
        setAdhar("");
        setOtp(["", "", "", ""]);
      }, 3000);
    } else {
      setModalText("Login Successfully!");
      setShowAccountModal(true);
      setTimeout(() => {
        setShowAccountModal(false);
        navigate("/");
      }, 3000);
    }
  };

  return (
    <div className="customer-card-container">
      <Form className="customer-form-body" onSubmit={handleFormSubmit}>
        {/* --- STATIC HEADER --- */}
        <div className="customer-header-row">
          <div className="customer-title-stack">
            <span className="customer-main-title">
              {isRegistering ? "Register as" : "Login as"} {activeTab}
            </span>
            <p className="customer-subtitle">to Oll Type Services</p>
          </div>
          <img
            src="./assets/header/Oll-Type-Services.png"
            alt="Logo"
            className="customer-brand-logo"
          />
        </div>

        {/* --- DYNAMIC BODY --- */}
        {!isRegistering ? (
          /* LOGIN VIEW: Non-scrollable */
          <div className="login-fields-container">
            <div className="customer-input-group">
              <PhoneInput country={"in"} value={mobile} onChange={setMobile} />
              <Form.Label className="static-label">Mobile No*</Form.Label>
            </div>
            <div className="customer-input-group">
              <Form.Control
                type="text"
                placeholder=" "
                required
                value={loginOtp}
                onChange={(e) => setLoginOtp(e.target.value)}
              />
              <Form.Label>Enter OTP*</Form.Label>
            </div>
          </div>
        ) : (
          <div className="scroll-form-body">
            <div className="register-fields-container">
              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  required
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
                <Form.Label>Full Name*</Form.Label>
              </div>

              <div className="customer-input-group">
                <PhoneInput
                  country={"in"}
                  value={mobile}
                  onChange={setMobile}
                />
                <Form.Label className="static-label">Mobile No*</Form.Label>
              </div>

              <div className="customer-otp-dotted-box">
                <Form.Label className="customer-otp-label">
                  Enter OTP
                </Form.Label>
                <div className="customer-otp-slots">
                  {otp.map((digit, index) => (
                    <div key={index} className="customer-otp-slot">
                      <Form.Control
                        id={`otp-${index}`}
                        type="text"
                        maxLength="1"
                        value={digit}
                        placeholder="●"
                        className="customer-otp-input"
                        onChange={(e) => handleChange(e.target.value, index)}
                        inputMode="numeric"
                      />
                      <hr className="customer-otp-line" />
                    </div>
                  ))}
                </div>
              </div>

              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  required
                  value={adhar}
                  onChange={(e) => setAdhar(e.target.value)}
                />
                <Form.Label>Adhar No*</Form.Label>
              </div>

              <div className="customer-input-group">
                <Select
                  options={cityOptions}
                  styles={selectStyles}
                  placeholder=""
                />
                <Form.Label className="floating-label">City*</Form.Label>
              </div>

              <div className="customer-input-group">
                <Select
                  options={stateOptions}
                  styles={selectStyles}
                  placeholder=""
                />
                <Form.Label className="floating-label">State*</Form.Label>
              </div>

              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  value={profession}
                  onChange={(e) => setProfession(e.target.value)}
                />
                <Form.Label>Profession</Form.Label>
              </div>

              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                />
                <Form.Label>Experience</Form.Label>
              </div>

              <div className="customer-input-group">
                <Form.Control
                  type="date"
                  placeholder=" "
                  value={dob}
                  onChange={(e) => setDob(e.target.value)}
                />
                <Form.Label className="static-label">DOB</Form.Label>
              </div>
            </div>
          </div>
        )}

        <div className="customer-footer-actions">
          <div className="footer-content-block">
            <Common_Login_Button text={isRegistering ? "Register" : "Login"} />
            <div className="customer-toggle-footer">
              <span className="acc-text">
                {isRegistering
                  ? "You have an account?"
                  : "Don't have an account?"}
              </span>
              <button
                type="button"
                className="customer-toggle-link"
                onClick={() => {
                  setIsRegistering(!isRegistering);
                  setOtp(["", "", "", ""]);
                }}
              >
                {isRegistering ? "Login Now" : "Create Account"}
              </button>
            </div>
          </div>
        </div>
      </Form>

      <Account_Created_Modal
        showAccountModal={showAccountModal}
        handleAccountModalClose={() => setShowAccountModal(false)}
        text={modalText}
      />
    </div>
  );
};

export default Expert_Login;
